require('./animate/Ease.js'); // Import to make sure ran once.
var limitNumber = require('./limitNumber.js');
var calcDistance = require('./calcDistance.js');
var getScrollParent = require('./getScrollParent.js');
var getOffsetSum = require('./getOffsetSum.js');

var $ = window.jQuery;

function scrollToElement(scrollToElem, padding, duration, easing) {
	if (padding === undefined || padding === null) {
		padding = 20;
	}

	// Check if in view
	// Uses viewport size (minus scrollbars)
	var viewportElem = getScrollParent(scrollToElem);
	var viewportWidth = viewportElem.clientWidth,
		viewportHeight = viewportElem.clientHeight,
		elemBounding = scrollToElem.getBoundingClientRect();
	if (
		elemBounding.top >= 0 && elemBounding.bottom <= viewportHeight
		&& elemBounding.left >= 0 && elemBounding.bottom <= viewportWidth
	) {
		return;
	}

	// Get a reference and stop any animations prior to starting the scroll animation
	var $viewportElem = $(viewportElem);
	$viewportElem.stop(true);

	// Calc and record animation data
	var offset = getOffsetSum(scrollToElem, viewportElem),
		originX = viewportElem.scrollLeft,
		originY = viewportElem.scrollTop;
	
	var destX = offset.left - padding,
		destY = offset.top - padding;
	
	if (duration === undefined || durnation === null) {
		duration = limitNumber(
			Math.abs(calcDistance(originX, originY, destX, destY)) * 1.5,
			250, 1000
		);
	}
	if (easing === undefined || easing === null) {
		easing = "easeOutSine";
	}
	
	// Do the animation
	$viewportElem.animate({
		scrollTop: destY,
		scrollLeft: destX
	}, {
		duration: duration,
		easing: easing
	});
}

module.exports =  scrollToElement;